import classnames from 'classnames'
import { Button } from '@/components'

import Image from 'next/image'

import styles from './styles.module.scss'

const CardPlanDetail = ({
  plan,
  variant,
  actionButton,
  disclaimer,
  isTestABCard = false,
  showValuePlan = true,
  showDescription = true,
  testAB
}) => {
  const buttonID = `btn-section-price-${plan?.value.split(',')[0]}`
  let planBenefits = plan?.list
  const showNewVersion = testAB === 'c' || testAB === 'd'

  if (showNewVersion) {
    planBenefits = plan?.list_b
  }

  return (
    <div style={{ flex: '1 1' }}>
      <div
        className={classnames(styles.cardDetail, {
          [`${styles.carDetailTestAB}`]: isTestABCard,
          [`${styles.cardDetailPink}`]: variant == 'pink'
        })}
      >
        <div className={styles.disclaimer}>{plan?.disclaimer}</div>
        <div className={styles.content}>
          <Image
            className={styles.logo}
            src={plan?.logo}
            alt={`Plano ${plan?.disclaimer}`}
            width={163}
            height={67}
          />
          {showValuePlan && (
            <>
              <p>A partir de</p>
              <Image
                src={plan?.priceImage}
                className={styles.price}
                alt={`Planos a partir de R$ ${plan?.value}`}
                width={134}
                height={66}
              />
              <p className={styles.cancelText}>
                {showNewVersion
                  ? 'Cancelamento grátis até o 7º dia.'
                  : 'Você pode cancelar até o 7º dia.'}
              </p>
            </>
          )}
          <div className={styles.topics}>
            {showDescription &&
              planBenefits?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={classnames(styles.planBenefits, {
                      [`${styles.hiddenOnMobile}`]: !item?.content
                    })}
                  >
                    {item.icon && (
                      <Image
                        className={styles.icon}
                        src={item.icon}
                        alt={item.content || 'Não disponível para este plano'}
                        width={35}
                        height={35}
                      />
                    )}
                    <h3>{item.content}</h3>
                  </div>
                )
              })}
          </div>
          <div className={styles.action}>
            <Button
              variant="primary"
              id={buttonID}
              className={styles.button}
              onClick={actionButton}
            >
              a partir de R$ {plan?.value}
            </Button>
          </div>
        </div>
      </div>
      {disclaimer}
    </div>
  )
}

export default CardPlanDetail
